import { HttpErrorResponse } from '@angular/common/http';

/**
 * Will be found in HttpErrorResponse.error
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export interface BackendError<T extends Record<string, unknown> = {}> {
  errors: Array<
    {
      message?: string;
      error?: unknown;
    } & T
  >;
}

export function asBackendError<T extends BackendError = BackendError>(err: unknown): T | undefined {
  if (!(err instanceof HttpErrorResponse)) {
    return undefined;
  }
  if (!Array.isArray(err.error?.errors)) {
    return { errors: [err.error] } as T;
  }
  return err.error as T;
}

export function getBackendErrorMessage<T extends BackendError = BackendError>(
  err: unknown,
  fallbackMessage = '',
  options: { messageProperty: keyof T['errors'][number]; joinWith?: string } = {
    messageProperty: 'message',
  },
): string {
  return (
    asBackendError<T>(err)
      ?.errors.map((e: T['errors'][number]) => `${e[options.messageProperty] ?? ''}`)
      .join(options.joinWith) || fallbackMessage
  );
}
